/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { IApplicationLog } from 'generated-types';
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

interface IL7ClientInfo extends Pick<IApplicationLog,
'client_location' | 'client_os' | 'client_device' | 'client_browser' | 'user_id'> {
    startTime?: string;
    endTime?: IApplicationLog['report_timestamp'];
    pfs?: string;
}

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * @description
 *     Pipe for extracting client info from an L7 log.
 * @author Zhiqian Liu
 */
@Pipe({
    name: 'l7ClientInfo',
})
export class L7ClientInfoPipe implements PipeTransform {
    /** @override */
    // eslint-disable-next-line class-methods-use-this
    public transform(log: IApplicationLog): IL7ClientInfo {
        if (!log) {
            return {};
        }

        const {
            client_location,
            client_os,
            client_device,
            client_browser,
            report_timestamp,
            total_time,
            user_id,
            ssl_cipher,
        } = log;

        return {
            client_location,
            client_os,
            client_device,
            client_browser,
            startTime: moment(report_timestamp).subtract(total_time, 'ms').toString(),
            endTime: report_timestamp,
            user_id,
            pfs: ssl_cipher?.split(/(?:PFS:)(\S*)/s)[1],
        };
    }
}
